import './index.css'
import React from 'react'

const DescriptionBenefits = () => {
  return (

    <div className='airshop-benefits-container'>
      <h2>Love your look</h2>
      <div className='airshop-benefits-wrapper'>
        <div>
          <svg
            width='56'
            height='56'
            viewBox='0 0 56 56'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <rect
              width='56'
              height='56'
              rx='28'
              fill='#FDECD5'
            />
            <path
              d='M30.625 14.5204C30.625 13.7794 31.2257 13.1787 31.9667 13.1787H40.8276C41.5717 13.1787 42.175 13.7819 42.175 14.5261V17.3787H30.625V14.5204Z'
              fill='white'
              stroke='#191531'
              strokeWidth='1.05'
            />
            <path
              d='M28.525 18.7203C28.525 17.9793 29.1257 17.3786 29.8667 17.3786H42.9333C43.6743 17.3786 44.275 17.9793 44.275 18.7203V23.387C44.275 24.128 43.6743 24.7286 42.9333 24.7286H29.8667C29.1257 24.7286 28.525 24.128 28.525 23.387V18.7203Z'
              fill='#E15EC4'
              stroke='#191531'
              strokeWidth='1.05'
            />
            <path
              d='M30.625 31.3203C30.625 30.5794 31.2257 29.9787 31.9667 29.9787H40.8276C41.5717 29.9787 42.175 30.5819 42.175 31.3261V34.1787H30.625V31.3203Z'
              fill='white'
              stroke='#191531'
              strokeWidth='1.05'
            />
            <path
              d='M28.525 35.5204C28.525 34.7794 29.1257 34.1787 29.8667 34.1787H42.9333C43.6743 34.1787 44.275 34.7794 44.275 35.5204V40.187C44.275 40.928 43.6743 41.5287 42.9333 41.5287H29.8667C29.1257 41.5287 28.525 40.928 28.525 40.187V35.5204Z'
              fill='#E15EC4'
              stroke='#191531'
              strokeWidth='1.05'
            />
            <path
              d='M13.3 19.5264C13.3 15.7307 16.377 12.6537 20.1727 12.6537C21.0162 12.6537 21.7 13.3375 21.7 14.181V24.2037H13.3V19.5264Z'
              fill='#FFC1F1'
              stroke='#191531'
              strokeWidth='1.05'
            />
            <path
              d='M16.4067 13.5597C18.5434 12.354 21.0126 12.2604 21.5658 13.4149C22.1189 14.5694 20.674 16.0885 18.4794 17.1588C16.2849 18.2291 13.3536 18.3845 13.3647 18.0726C13.3759 17.7606 13.7214 15.0751 16.4067 13.5597Z'
              fill='white'
              stroke='#191531'
              strokeWidth='1.05'
            />
            <path
              d='M11.725 25.0204C11.725 24.2794 12.3257 23.6787 13.0667 23.6787H21.9333C22.6743 23.6787 23.275 24.2794 23.275 25.0204V28.9287H11.725V25.0204Z'
              fill='white'
              stroke='#191531'
              strokeWidth='1.05'
            />
            <path
              d='M11.725 28.9287H23.275V40.187C23.275 40.928 22.6743 41.5287 21.9333 41.5287H13.0667C12.3257 41.5287 11.725 40.928 11.725 40.187V28.9287Z'
              fill='#E15EC4'
              stroke='#191531'
              strokeWidth='1.05'
            />
          </svg>

          <h5>Sample everything</h5>
          <p>
            Pick from 5,000+ free samples of makeup, skincare, and more!
          </p>
        </div>

        <div>
          <svg
            width='56'
            height='56'
            viewBox='0 0 56 56'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <rect
              width='56'
              height='56'
              rx='28'
              fill='#FDECD5'
            />
            <path
              d='M26.9826 27.9217L15.4361 33.695C14.3745 34.2258 14.4136 35.754 15.5011 36.2298L27.0881 41.2991C27.6694 41.5534 28.3306 41.5534 28.9119 41.2991L40.4989 36.2298C41.5864 35.754 41.6255 34.2258 40.5639 33.695L29.0174 27.9217C28.3769 27.6015 27.6231 27.6015 26.9826 27.9217Z'
              fill='white'
              stroke='#191531'
              strokeWidth='1.05'
              strokeLinecap='round'
            />
            <path
              d='M28 40.6621V25.6445C28 24.9493 28.4116 24.3199 29.0486 24.0413L39.5486 19.4475C40.7048 18.9417 42 19.7888 42 21.0508V34.7305C42 35.4257 41.5884 36.0551 40.9514 36.3337L29.2257 41.4637C28.6476 41.7167 28 41.2931 28 40.6621Z'
              fill='#E15EC4'
              stroke='#191531'
              strokeWidth='1.05'
            />
            <path
              d='M26.9514 24.0413L16.4514 19.4475C15.2952 18.9417 14 19.7888 14 21.0508V34.7305C14 35.4257 14.4116 36.0551 15.0486 36.3337L26.7743 41.4637C27.3524 41.7167 28 41.2931 28 40.6621V25.6445C28 24.9493 27.5884 24.3199 26.9514 24.0413Z'
              fill='#FFC1F1'
              stroke='#191531'
              strokeWidth='1.05'
            />
            <path
              d='M27.0881 13.8259L14.889 19.163L15.0994 19.644L14.889 19.163C14.0501 19.53 14.0501 20.72 14.889 21.087L27.0881 26.4241C27.6694 26.6784 28.3306 26.6784 28.9119 26.4241L41.111 21.087C41.9499 20.72 41.9499 19.53 41.111 19.163L28.9119 13.8259C28.3306 13.5716 27.6694 13.5716 27.0881 13.8259Z'
              fill='white'
              stroke='#191531'
              strokeWidth='1.05'
              strokeLinecap='round'
            />
            <path
              d='M21 16.625L35.875 23.625V30.625'
              stroke='#191531'
              strokeWidth='1.05'
              strokeLinecap='round'
            />
          </svg>
          <h5>Try it from your home</h5>
          <p>
            Have samples sent straight to your home and find your perfect match.
          </p>
        </div>

        <div>
          <svg
            width='56'
            height='56'
            viewBox='0 0 56 56'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <rect
              width='56'
              height='56'
              rx='28'
              fill='#FDECD5'
            />
            <circle
              cx='28'
              cy='28'
              r='15.4'
              fill='white'
              stroke='#191531'
              strokeWidth='1.05'
              strokeLinecap='round'
            />
            <circle
              cx='28'
              cy='24.92'
              r='4.62'
              fill='#FFC1F1'
              stroke='#191531'
              strokeWidth='1.05'
            />
            <path
              d='M18.76 40.3212V39.55C18.76 36.3606 21.3456 33.775 24.535 33.775H31.465C34.6545 33.775 37.24 36.3606 37.24 39.55V40.3211C34.6662 42.2544 31.4669 43.4 28 43.4C24.5332 43.4 21.3339 42.2544 18.76 40.3212Z'
              fill='#E15EC4'
              stroke='#191531'
              strokeWidth='1.05'
            />
          </svg>
          <h5>Upgrade to full-size</h5>
          <p>
            Once you know you love a product enjoy 20% off the full size of your favorite.
          </p>
        </div>
      </div>
      <a
        href='/collections/sample-collection'
        className='why-shop-all-samples-btn'
      >
        Shop all samples
      </a>
    </div>
  )
}

export default DescriptionBenefits
